import { useState } from "react";
import { Quote, Building2 } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { TESTIMONIALS } from "@/data/testimonials";

export default function TestimonialsSection() {
  if (!TESTIMONIALS || TESTIMONIALS.length === 0) return null;
  return (
    <section className="section bg-industrial-soft" data-testid="testimonials-section">
      <div className="container-nago">
        <SectionHeading
          eyebrow="Testimonials"
          title="What our clients say."
          description="Trusted by manufacturers, foundries and engineering enterprises across India."
          align="center"
        />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <TestimonialCard key={`${t.company}-${i}`} data={t} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ data }) {
  const [logoError, setLogoError] = useState(false);
  const { logo, company, person_name, designation, review } = data;

  return (
    <article
      className="relative bg-white border border-slate-200 rounded-2xl p-6 sm:p-7 flex flex-col hover:shadow-xl hover:-translate-y-1 hover:border-slate-300 transition-all duration-300"
      data-testid={`testimonial-${company.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
    >
      <Quote className="w-8 h-8 text-[#E30613]/25 absolute top-5 right-5" aria-hidden />
      <p className="text-slate-700 leading-relaxed text-sm sm:text-base italic">
        &ldquo;{review}&rdquo;
      </p>
      <div className="mt-6 flex items-center gap-4 pt-5 border-t border-slate-100">
        <div className="w-14 h-14 shrink-0 bg-white border border-slate-200 rounded-xl flex items-center justify-center p-1.5 overflow-hidden">
          {logo && !logoError ? (
            <img
              src={logo}
              alt={`${company} logo`}
              onError={() => setLogoError(true)}
              className="max-h-full max-w-full object-contain"
              loading="lazy"
            />
          ) : (
            <Building2 className="w-6 h-6 text-[#1E3A8A]" />
          )}
        </div>
        <div className="min-w-0">
          <div className="font-display font-bold text-slate-900 leading-tight">
            {person_name}
          </div>
          {designation && (
            <div className="text-xs text-slate-500 mt-0.5 leading-snug">{designation}</div>
          )}
          <div className="text-xs text-[#1E3A8A] font-semibold mt-1 truncate">{company}</div>
        </div>
      </div>
    </article>
  );
}
